import { configureStore } from '@reduxjs/toolkit'
import userSlice from './slices/userSlice'
import postReducer from './slices/postSlice'
import exploreReducer from './slices/exploreSlice'
import commentReducer from './slices/commentSlice'
import messageSlice from './slices/messageSlice'
import settingSlice from './slices/settingSlice'
import authReducer from "./slices/authSlice";
import viewedProfileReducer from './slices/viewedProfileSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

export const store = configureStore({
  reducer: {
    user: userSlice,
    posts: postReducer,
    explore: exploreReducer,
    comment: commentReducer,
    message: messageSlice,
    setting: settingSlice,
    auth: authReducer,
    viewedProfile: viewedProfileReducer,
    subscription: subscriptionReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

// Use AppDispatch instead of plain useDispatch
export const useAppDispatch: () => AppDispatch = useDispatch;

// Use RootState instead of plain useSelector
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;